import { Link } from 'react-router';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { accessRoleLabel } from '@/lib/labels';
import { actingOrgUnitTypeOf } from '@/lib/accessRole';

/**
 * 403.
 *
 * ⚠️ IT NEVER NAMES THE MISSING CAPABILITY. A debug code in a 403 body is an enumeration
 * aid: it tells someone probing exactly which permission to go looking for. CLAUDE.md §10.
 */
const ForbiddenPage = () => {
  const { officer } = useAuth();

  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-24 text-center">
      <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary">
        <ShieldOff className="size-5 text-muted-foreground" aria-hidden />
      </span>
      <div>
        <h1 className="text-xl font-semibold tracking-tight">You do not have access to this page</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Your access is {officer ? accessRoleLabel(officer.accessRole, actingOrgUnitTypeOf(officer)) : 'limited'}. If
          this is wrong, ask a super admin to change it.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/">Back to overview</Link>
      </Button>
    </div>
  );
};

export default ForbiddenPage;
